import type { SellerRecommendation } from './api/seller-recommendation';

export const GET_SELLER_RECOMMENDATIONS = 'GET_SELLER_RECOMMENDATIONS';
type GetSellerRecommendationsAction = { type: typeof GET_SELLER_RECOMMENDATIONS };
export const getSellerRecommendations = (): GetSellerRecommendationsAction => ({
  type: GET_SELLER_RECOMMENDATIONS,
});

export const GET_SELLER_RECOMMENDATIONS_SUCCESS = 'GET_SELLER_RECOMMENDATIONS_SUCCESS';
type GetSellerRecommendationsSuccessAction = {
  type: typeof GET_SELLER_RECOMMENDATIONS_SUCCESS;
  recommendations: SellerRecommendation[];
};
export const getSellerRecommendationsSuccess = (recommendations: SellerRecommendation[]): GetSellerRecommendationsSuccessAction => ({
  type: GET_SELLER_RECOMMENDATIONS_SUCCESS,
  recommendations,
});

export type SellerRecommendationsAction = GetSellerRecommendationsAction | GetSellerRecommendationsSuccessAction;
